<template>
    <div class="rulerManagement fadeInRight">
        <div class="title-box clearfix">
            <span class="m-title">池卡管理</span>
            <el-form
                :inline="true"
                :model="formInline"
                class="right themed-form search-form"
                style="height: auto; line-height: 40px"
            >
                <el-form-item label="流量池:">
                    <el-select
                        v-model="formInline.poolId"
                        filterable
                        placeholder="请选择流量池"
                        clearable
                    >
                        <el-option
                            v-for="(item, index) in carPoolLists"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="卡状态:">
                    <el-select
                        v-model="formInline.status"
                        filterable
                        placeholder="请选择卡状态"
                        clearable
                    >
                        <el-option label="未激活" value="1"></el-option>
                        <el-option label="正常" value="2"></el-option>
                        <el-option label="停机" value="4"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="ICCID:">
                    <el-input
                        v-model="formInline.iccid"
                        placeholder="请输入ICCID"
                        clearable
                    ></el-input>
                </el-form-item>
                <el-form-item label="EID:">
                    <el-input
                        v-model="formInline.eid"
                        placeholder="请输入EID"
                        clearable
                    ></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button
                        type="primary"
                        @click="searchData"
                        icon="el-icon-search"
                        class="themed-button"
                        >搜索</el-button
                    >
                </el-form-item>

                <el-form-item>
                    <el-button
                        type="primary"
                        @click="addPool"
                        icon="el-icon-plus"
                        class="themed-button"
                        v-if="currentRole == 0"
                        >导卡入池</el-button
                    >
                    <el-button
                        type="primary"
                        @click="batchUpdate"
                        icon="el-icon-edit-outline"
                        class="themed-button"
                        >批量更改</el-button
                    >
                    <el-button
                        type="primary"
                        @click="batchDelete"
                        icon="el-icon-edit-outline"
                        class="themed-button"
                        >批量删除</el-button
                    >

                    <el-button
                        type="primary"
                        @click="exportList"
                        icon="el-icon-plus"
                        class="themed-button"
                        >导出</el-button
                    >
                </el-form-item>
            </el-form>
        </div>
        <div class="content-box">
            <el-table
                :data="tabledata"
                stripe
                style="width: 100%"
                border
                ref="table"
                :max-height="maxTableHeight"
            >
                <el-table-column prop="iccid" label="iccid" min-width="180">
                </el-table-column>
                <el-table-column prop="eid" label="EID" min-width="180">
                </el-table-column>
                <el-table-column prop="cardNo" label="接入号" min-width="130">
                </el-table-column>
                <el-table-column
                    prop="poolName"
                    label="卡池名称"
                    min-width="100"
                >
                </el-table-column>
                <el-table-column prop="status" label="卡状态" min-width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == '1'">未激活</span>
                        <span v-else-if="scope.row.status == '2'">正常</span>
                        <span v-else-if="scope.row.status == '4'">停机</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="realnameStatus"
                    label="实名状态"
                    min-width="100"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.realnameStatus">已实名</span>
                        <span v-else>未实名</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="joinStatus"
                    label="入池状态"
                    min-width="100"
                >
                    <template v-slot:default="scope">
                        <span v-if="scope.row.joinStatus">已入池</span>
                        <span v-else>未入池</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="joinTime"
                    label="入池时间"
                    min-width="130"
                >
                </el-table-column>
                <el-table-column
                    prop="exitTime"
                    label="出池时间"
                    min-width="130"
                >
                </el-table-column>
                <el-table-column prop="province" label="省份" min-width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.province">{{
                            scope.row.province
                        }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="joinStatus"
                    label="第三方管理"
                    min-width="100"
                >
                    <template v-slot:default="scope">
                        <span v-if="scope.row.thirdManage">是</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="pollCount"
                    label="轮询计数"
                    min-width="130"
                >
                </el-table-column>

                <el-table-column
                    label="操作"
                    width="320px"
                    v-if="currentRole == 0"
                >
                    <template v-slot:default="scope">
                        <el-button
                            type="info"
                            class="themed-button"
                            @click="deleteRow(scope.row.id)"
                            >删除</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                :current-page.sync="page"
                :page-sizes="[10, 15, 25, 100]"
                :page-size="pageSize"
                style="text-align: left; margin-top: 20px"
                background
                layout="total,sizes,prev, pager, next,jumper"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="onPageChange"
            >
            </el-pagination>
        </div>
        <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogAddVisible"
            v-if="dialogAddVisible"
        >
            <el-form :model="addForm" :rules="rules" ref="addForm">
                <el-form-item
                    label="流量池"
                    :label-width="formLabelWidth"
                    prop="poolId"
                    v-if="dialogTitle == '导卡入池'"
                >
                    <el-select
                        v-model="addForm.poolId"
                        filterable
                        placeholder="请选择流量池"
                        clearable
                    >
                        <el-option
                            v-for="(item, index) in carPoolLists"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    label="选择excel文件:"
                    :label-width="formLabelWidth"
                    :required="isRequired"
                    prop="file"
                >
                    <input class="file-input" type="file" ref="file" />
                    <div class="mt5">
                        <span class="text-color" style="font-size: 12px"
                            >仅支持.xls/.xlsx格式</span
                        >
                        <!-- <el-button
                            type="text"
                            size="small"
                            @click="downloadTemplate"
                            style="margin-left: 10px; color: #409eff"
                            >下载模板</el-button
                        > -->
                    </div>
                </el-form-item>
                <el-form-item
                    label="ICCID/短号"
                    :label-width="formLabelWidth"
                    prop="iccid"
                >
                    <el-input
                        type="textarea"
                        autosize
                        placeholder="请输入ICCID/短号，多个换行隔开"
                        v-model="addForm.iccid"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item
                    label="是否第三方管理"
                    :label-width="formLabelWidth"
                    prop="thirdManage"
                >
                    <el-radio-group v-model="addForm.thirdManage">
                        <el-radio label="1">是</el-radio>
                        <el-radio label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item
                    label="省份"
                    :label-width="formLabelWidth"
                    prop="province"
                >
                    <el-select
                        v-model="addForm.province"
                        placeholder="请选择省份"
                        clearable
                    >
                        <el-option label="北京市" value="北京市"></el-option>
                        <el-option label="天津市" value="天津市"></el-option>
                        <el-option label="河北省" value="河北省"></el-option>
                        <el-option label="山西省" value="山西省"></el-option>
                        <el-option
                            label="内蒙古自治区"
                            value="内蒙古自治区"
                        ></el-option>
                        <el-option label="辽宁省" value="辽宁省"></el-option>
                        <el-option label="吉林省" value="吉林省"></el-option>
                        <el-option
                            label="黑龙江省"
                            value="黑龙江省"
                        ></el-option>
                        <el-option label="上海市" value="上海市"></el-option>
                        <el-option label="江苏省" value="江苏省"></el-option>
                        <el-option label="浙江省" value="浙江省"></el-option>
                        <el-option label="安徽省" value="安徽省"></el-option>
                        <el-option label="福建省" value="福建省"></el-option>
                        <el-option label="江西省" value="江西省"></el-option>
                        <el-option label="山东省" value="山东省"></el-option>
                        <el-option label="河南省" value="河南省"></el-option>
                        <el-option label="湖北省" value="湖北省"></el-option>
                        <el-option label="湖南省" value="湖南省"></el-option>
                        <el-option label="广东省" value="广东省"></el-option>
                        <el-option
                            label="广西壮族自治区"
                            value="广西壮族自治区"
                        ></el-option>
                        <el-option label="海南省" value="海南省"></el-option>
                        <el-option label="重庆市" value="重庆市"></el-option>
                        <el-option label="四川省" value="四川省"></el-option>
                        <el-option label="贵州省" value="贵州省"></el-option>
                        <el-option label="云南省" value="云南省"></el-option>
                        <el-option
                            label="西藏自治区"
                            value="西藏自治区"
                        ></el-option>
                        <el-option label="陕西省" value="陕西省"></el-option>
                        <el-option label="甘肃省" value="甘肃省"></el-option>
                        <el-option label="青海省" value="青海省"></el-option>
                        <el-option
                            label="宁夏回族自治区"
                            value="宁夏回族自治区"
                        ></el-option>
                        <el-option
                            label="新疆维吾尔自治区"
                            value="新疆维吾尔自治区"
                        ></el-option>
                        <el-option label="台湾省" value="台湾省"></el-option>
                        <el-option
                            label="香港特别行政区"
                            value="香港特别行政区"
                        ></el-option>
                        <el-option
                            label="澳门特别行政区"
                            value="澳门特别行政区"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    @click="formAddSubmit('addForm')"
                    class="themed-button"
                    >确 定</el-button
                >
                <el-button
                    type="primary"
                    @click="formAddReset('addForm')"
                    class="themed-button"
                    >重置</el-button
                >
                <el-button type="primary" class="themed-button" @click="exportTemplateExcel">导出excel模板</el-button>
                <el-button
                    type="info"
                    @click="dialogAddVisible = false"
                    class="themed-button"
                    >取 消</el-button
                >
            </div>
        </el-dialog>
        <el-dialog title="批量删除" :visible.sync="dialogBox">
            <el-form label-position="right" label-width="120px" ref="form"
                ><el-form-item label="选择excel文件:" :required="isRequired">
                    <input class="file-input" type="file" ref="file" />
                    <div class="mt5">
                        <span class="text-color" style="font-size: 12px"
                            >仅支持.xls/.xlsx格式</span
                        >
                        <!-- <el-button
                            type="text"
                            size="small"
                            @click="downloadTemplate"
                            style="margin-left: 10px; color: #409eff"
                            >下载模板</el-button
                        > -->
                    </div>
                </el-form-item>
                <el-form-item label="ICCID/短号">
                    <el-input
                        v-model="form.iccids"
                        type="textarea"
                        :placeholder="placeholderText"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="uploadExcel"
                    >确认</el-button
                >
                <el-button type="primary" class="themed-button" @click="exportTemplateExcel">导出excel模板</el-button>
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="dialogBox = false"
                    >取 消</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import onresize from "@/mixins/resize.js";
import { mapGetters } from "vuex";
import {
    cardNoExport,
    cardNoList,
    deleteCardNo,
    getCardPoolList,
    cardNoAdd,
    batchUpdate,
    batchDeleteByExcelSync,
    batchAddByExcelSync,
    batchUpdateByExcelSync,
} from "@/api/trafficPoolManagement.js";
import { exportTemplate } from "@/api/statistics.js";
import { messageBox, confirmBox } from "@/utils/common.js";
import Utils from "@/utils/utils.js";

export default {
    name: "poolCardManagement",
    mixins: [onresize],
    data() {
        return {
            page: 1,
            pageSize: 15,
            total: 0,
            formInline: {
                iccid: null,
                poolId: null,
                status: null,
                eid: null,
            },
            tabledata: [],
            formLabelWidth: "200px",
            dialogAddVisible: false,
            addForm: {
                iccid: "",
                poolId: "",
                thirdManage: "",
                province: "",
            },
            rules: {
                iccid: [
                    { required: false, message: "请输入卡号", trigger: "blur" },
                ],
                poolId: [
                    {
                        required: true,
                        message: "请选择流量池",
                        trigger: "change",
                    },
                ],
                thirdManage: [
                    {
                        required: true,
                        message: "请选择是否第三方管理",
                        trigger: "change",
                    },
                ],
            },
            carPoolLists: [],
            dialogTitle: "",
            dialogBox: false,
            isRequired: false,
            placeholderText: "请输入ICCID/短号",
            form: {
                iccids: "",
            },
        };
    },
    created() {
        this.getCardPoolList();
        this.getPoolCardList();
    },
    components: {},
    computed: {
        ...mapGetters(["currentRole"]),
    },
    methods: {
        batchUpdate() {
            this.dialogAddVisible = true;
            this.dialogTitle = "批量更改";
            this.addForm.iccid = "";
            this.addForm.thirdManage = "";
            this.addForm.province = "";
        },
        batchDelete() {
            console.log("批量删除");
            this.dialogBox = true;
        },
        uploadExcel() {
            confirmBox(this, "确定批量删除吗？", "操作提示", () => {
                this.comfirmImport();
            });
        },
        comfirmImport() {
            let file = this.$refs["file"].files[0];
            if (file) {
                let fileName = file.name;
                let index = fileName.lastIndexOf(".");
                if (
                    index < 0 ||
                    !(
                        fileName.substring(index + 1, fileName.length) ==
                            "xls" ||
                        fileName.substring(index + 1, fileName.length) == "xlsx"
                    )
                ) {
                    messageBox(this, "文件格式错误");
                    return;
                } else if (!!Utils.checkFile(file)) {
                    if (Utils.checkFile(file) == 1) {
                        messageBox(this, "上传文件不能超过20M");
                        return;
                    } else if (Utils.checkFile(file) == 2) {
                        messageBox(this, "上传文件名称长度不能超过36个字符");
                        return;
                    }
                } else {
                    let params = new FormData();
                    params.append("fileurl", file);
                    // params.append("type", 1);
                    params.append("fromRange", false);

                    batchDeleteByExcelSync(params)
                        .then((res) => {
                            // 响应拦截器在成功时可能直接返回data字段，所以res可能是字符串
                            if (typeof res === "string") {
                                // 如果res是字符串，说明请求成功，res就是返回的消息
                                let alertMessage =
                                    res || "批量删除任务已提交，请稍后查看结果";
                                this.$alert(alertMessage, "提示", {
                                    confirmButtonText: "确定",
                                }).then(() => {
                                    this.dialogBox = false;
                                    // 跳转到导入结果页面查看删除结果
                                    this.$router.push("/tob/i_import_list");
                                });
                            } else if (
                                res &&
                                (res.code == "0" ||
                                    res.app_result_key == "0" ||
                                    res.system_result_key == "0")
                            ) {
                                // 如果res是对象且成功
                                let alertMessage =
                                    res.data ||
                                    "批量删除任务已提交，请稍后查看结果";
                                this.$alert(alertMessage, "提示", {
                                    confirmButtonText: "确定",
                                }).then(() => {
                                    this.dialogBox = false;
                                    // 跳转到导入结果页面查看删除结果
                                    this.$router.push("/tob/i_import_list");
                                });
                            } else {
                                this.$message({
                                    showClose: true,
                                    message:
                                        res.system_result_message_key ||
                                        res.message ||
                                        "删除失败",
                                    type: "error",
                                });
                                this.dialogBox = false; // 关闭对话框
                            }
                        })
                        .catch((error) => {
                            console.error("批量删除请求失败:", error);
                            this.$message({
                                showClose: true,
                                message: "请求失败，请重试",
                                type: "error",
                            });
                            this.dialogBox = false; // 关闭对话框
                        });
                }
            } else {
                let params = new FormData();
                params.append("iccids", this.form.iccids);
                batchDeleteByExcelSync(params).then((res) => {
                    console.log(res);

                    if (res.fail == "0") {
                        // 判断是否为修改流量类型为本省流量的情况
                        let alertMessage = "批量删除成功";
                        this.$alert(alertMessage, "提示", {
                            confirmButtonText: "确定",
                        }).then(() => {
                            this.dialogBox = false;
                            this.getPoolCardList();
                            // this.$router.push("/tob/i_import_list");
                        });
                    } else {
                        let error = "";
                        res.failList.forEach((element) => {
                            error += element + " , ";
                        });
                        this.$message({
                            showClose: true,
                            message: error,
                            type: "error",
                        });
                    }
                });
            }
        },
        getCardPoolList() {
            let params = {
                pageSize: 1000000,
                pageNo: 1,
            };
            getCardPoolList(params).then((res) => {
                this.carPoolLists = res.rows.map((value, index, arr) => {
                    return { value: value.id, label: value.name };
                });
            });
        },
        addPool() {
            this.getCardPoolList();
            this.dialogAddVisible = true;
            this.dialogTitle = "导卡入池";
            this.addForm.iccid = "";
            this.addForm.poolId = "";
            this.addForm.thirdManage = "";
            this.addForm.province = "";
        },
        deleteRow(id) {
            this.$confirm("是否确认删除?", "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                deleteCardNo({ id }).then((res) => {
                    this.getPoolCardList();
                    this.$message({
                        type: "success",
                        message: "删除成功",
                    });
                });
            });
        },
        formAddSubmit(formName) {
            let file = this.$refs["file"].files[0];
            if (file) {
                let fileName = file.name;
                let index = fileName.lastIndexOf(".");
                if (
                    index < 0 ||
                    !(
                        fileName.substring(index + 1, fileName.length) ==
                            "xls" ||
                        fileName.substring(index + 1, fileName.length) == "xlsx"
                    )
                ) {
                    messageBox(this, "文件格式错误");
                    return;
                } else if (!!Utils.checkFile(file)) {
                    if (Utils.checkFile(file) == 1) {
                        messageBox(this, "上传文件不能超过20M");
                        return;
                    } else if (Utils.checkFile(file) == 2) {
                        messageBox(this, "上传文件名称长度不能超过36个字符");
                        return;
                    }
                } else {
                    let params = new FormData();
                    params.append("fileurl", file);
                    // params.append("type", 1);
                    params.append("fromRange", false);
                    params.append("poolId", this.addForm.poolId);
                    params.append("thirdManage", this.addForm.thirdManage);
                    params.append("province", this.addForm.province);
                    if (this.dialogTitle == "导卡入池") {
                        batchAddByExcelSync(params)
                            .then((res) => {
                                // 响应拦截器在成功时可能直接返回data字段，所以res可能是字符串
                                if (typeof res === "string") {
                                    // 如果res是字符串，说明请求成功，res就是返回的消息
                                    let alertMessage =
                                        res ||
                                        "批量导入任务已提交，请稍后查看结果";
                                    this.$alert(alertMessage, "提示", {
                                        confirmButtonText: "确定",
                                    }).then(() => {
                                        this.dialogAddVisible = false;
                                        this.$router.push("/tob/i_import_list");
                                    });
                                } else if (
                                    res &&
                                    (res.code == "0" ||
                                        res.app_result_key == "0" ||
                                        res.system_result_key == "0")
                                ) {
                                    // 如果res是对象且成功
                                    let alertMessage =
                                        res.data ||
                                        "批量导入任务已提交，请稍后查看结果";
                                    this.$alert(alertMessage, "提示", {
                                        confirmButtonText: "确定",
                                    }).then(() => {
                                        this.dialogAddVisible = false;
                                        this.$router.push("/tob/i_import_list");
                                    });
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message:
                                            res.system_result_message_key ||
                                            res.message ||
                                            "导入失败",
                                        type: "error",
                                    });
                                    this.dialogAddVisible = false; // 关闭对话框
                                }
                            })
                            .catch((error) => {
                                console.error("批量导入请求失败:", error);
                                this.$message({
                                    showClose: true,
                                    message: "请求失败，请重试",
                                    type: "error",
                                });
                                this.dialogAddVisible = false; // 关闭对话框
                            });
                    } else {
                        batchUpdateByExcelSync(params)
                            .then((res) => {
                                // 响应拦截器在成功时可能直接返回data字段，所以res可能是字符串
                                if (typeof res === "string") {
                                    // 如果res是字符串，说明请求成功，res就是返回的消息
                                    let alertMessage =
                                        res ||
                                        "批量更改任务已提交，请稍后查看结果";
                                    this.dialogBox = false; // 先关闭对话框
                                    this.$alert(alertMessage, "提示", {
                                        confirmButtonText: "确定",
                                    }).then(() => {
                                        // 强制清除所有模态层
                                        this.$nextTick(() => {
                                            // 移除所有v-modal遮罩层
                                            const modals =
                                                document.querySelectorAll(
                                                    ".v-modal"
                                                );
                                            modals.forEach((modal) =>
                                                modal.remove()
                                            );

                                            setTimeout(() => {
                                                this.$router.push(
                                                    "/tob/i_import_list"
                                                );
                                            }, 50);
                                        });
                                    });
                                } else if (
                                    res &&
                                    (res.code == "0" ||
                                        res.app_result_key == "0" ||
                                        res.system_result_key == "0")
                                ) {
                                    // 如果res是对象且成功
                                    let alertMessage =
                                        res.data ||
                                        "批量更改任务已提交，请稍后查看结果";
                                    this.dialogBox = false; // 先关闭对话框
                                    this.$alert(alertMessage, "提示", {
                                        confirmButtonText: "确定",
                                    }).then(() => {
                                        // 强制清除所有模态层
                                        this.$nextTick(() => {
                                            // 移除所有v-modal遮罩层
                                            const modals =
                                                document.querySelectorAll(
                                                    ".v-modal"
                                                );
                                            modals.forEach((modal) =>
                                                modal.remove()
                                            );

                                            setTimeout(() => {
                                                this.$router.push(
                                                    "/tob/i_import_list"
                                                );
                                            }, 50);
                                        });
                                    });
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message:
                                            res.system_result_message_key ||
                                            res.message ||
                                            "更改失败",
                                        type: "error",
                                    });
                                    this.dialogBox = false; // 关闭对话框
                                }
                            })
                            .catch((error) => {
                                console.error("批量更改请求失败:", error);
                                this.$message({
                                    showClose: true,
                                    message: "请求失败，请重试",
                                    type: "error",
                                });
                                this.dialogBox = false; // 关闭对话框
                            });
                    }
                }
            } else {
                //新增规则确认
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let tipContent = "";
                        if (this.addForm.thirdManage == 1) {
                            // this.addForm.thirdManage = true
                            tipContent =
                                "请确认该批卡已由第三方系统进行套餐停复机管理，否则可能导致不停机。";
                        } else {
                            tipContent =
                                "请确认该批卡不在第三方系统中，否则可能导致反复停复机。";
                            //  this.addForm.thirdManage = false
                        }
                        this.$confirm(tipContent, "提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning",
                        }).then(() => {
                            if (this.dialogTitle == "导卡入池") {
                                console.log("导入");

                                cardNoAdd(this.addForm).then((res) => {
                                    if (res.system_result_key == "0") {
                                        this.$message({
                                            showClose: true,
                                            message: "导卡入池成功",
                                            type: "success",
                                        });
                                        this.dialogAddVisible = false;
                                        this.getPoolCardList();
                                    } else {
                                        this.$message({
                                            showClose: true,
                                            message:
                                                res.system_result_key_message,
                                            type: "error",
                                        });
                                    }
                                });
                            } else {
                                console.log(this.addForm);
                                let params = {
                                    iccid: this.addForm.iccid,
                                    thirdManage: this.addForm.thirdManage,
                                    province: this.addForm.province,
                                };
                                batchUpdate(params).then((res) => {
                                    if (res.system_result_key == "0") {
                                        this.$message({
                                            showClose: true,
                                            message: "批量更改成功",
                                            type: "success",
                                        });
                                        this.dialogAddVisible = false;
                                        this.getPoolCardList();
                                    } else {
                                        this.$message({
                                            showClose: true,
                                            message:
                                                res.system_result_message_key,
                                            type: "error",
                                        });
                                    }
                                });
                            }
                        });
                    } else {
                        return false;
                    }
                });
            }
        },
        formAddReset(formName) {
            this.$refs[formName].resetFields();
        },

        exportList() {
            //导出
            let params = {};
            if (!!this.formInline.iccid) {
                params.iccid = this.formInline.iccid;
            }
            if (!!this.formInline.poolId) {
                params.poolId = this.formInline.poolId;
            }
            if (!!this.formInline.status) {
                params.status = this.formInline.status;
            }
            if (!!this.formInline.eid) {
                params.eid = this.formInline.eid;
            }
            cardNoExport(params).then((res) => {
                if (res.system_result_key == "0") {
                    this.$alert("导出成功，请到导出记录中下载", "提示", {
                        confirmButtonText: "确定",
                    }).then(() => {
                        this.$router.push("/tob/i_export_list");
                    });
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: "error",
                    });
                }
            });
        },

        getPoolCardList() {
            let params = {
                pageSize: this.pageSize,
                pageNo: this.page,
            };

            if (!!this.formInline.iccid) {
                params.iccid = this.formInline.iccid;
            }
            if (!!this.formInline.poolId) {
                params.poolId = this.formInline.poolId;
            }
            if (!!this.formInline.status) {
                params.status = this.formInline.status;
            }
            if (!!this.formInline.eid) {
                params.eid = this.formInline.eid;
            }
            // Object.assign(params, this.formInline);
            cardNoList(params).then((res) => {
                /* 表格数据 */
                this.tabledata = res.rows;
                this.page = res.pageNo;
                this.pageSize = res.pageSize;
                this.total = res.total;
            });
        },
        handleSizeChange(size) {
            this.pageSize = size;
            this.getPoolCardList();
        },
        onPageChange(page) {
            this.page = page;
            this.getPoolCardList();
        },
        searchData() {
            this.page = 1;
            this.getPoolCardList();
        },

        exportTemplateExcel(){
            let name ;
                name = "importIccidOrShort.xls";
            exportTemplate({name}).then(res=>{
                const filename = name
                Utils.createDownload(res,filename)
            })
        },


        // downloadTemplate() {
            // 下载模板
            // exportTemplate()
            //     .then((res) => {
            //         const blob = new Blob([res], {
            //             type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            //         });
            //         const url = window.URL.createObjectURL(blob);
            //         const link = document.createElement("a");
            //         link.href = url;
            //         link.download = "模板文件.xlsx";
            //         document.body.appendChild(link);
            //         link.click();
            //         document.body.removeChild(link);
            //         window.URL.revokeObjectURL(url);
            //         this.$message({
            //             type: "success",
            //             message: "模板下载成功",
            //         });
            //     })
            //     .catch((error) => {
            //         this.$message({
            //             type: "error",
            //             message: "模板下载失败",
            //         });
            //         console.error("下载模板失败:", error);
            //     });
        // },
    },
};
</script>

<style>
.right_agent {
    margin-right: 8px;
}
.rulerManagement .el-form-item__label {
    vertical-align: top;
}
</style>
